// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern AI-Style Header */

.headerDiv {
    background: rgba(255, 255, 255, 0.95);
    -webkit-backdrop-filter: blur(20px);
            backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(102, 126, 234, 0.1);
    color: #fff;
    padding: 0;
    position: fixed;
    width: 100%;
    z-index: 1000;
    height: 70px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.headerDiv:hover {
    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
}

.headerContainer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    padding: 0 40px;
    max-width: 1600px;
    margin: 0 auto;
}

/* Left Section - Logo */
.headerLeft {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.headerLogoImg {
    cursor: pointer;
    transition: all 0.3s ease;
    height: auto;
}

.headerLogoImg:hover {
    transform: scale(1.05);
    opacity: 0.9;
}

/* Right Section */
.headerRight {
    display: flex;
    align-items: center;
    gap: 32px;
    flex: 1 1;
    justify-content: flex-end;
}

/* Navigation */
.headerNav {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
    justify-content: center;
}

.navItem {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 15px;
    font-weight: 500;
    color: #4b5563;
    position: relative;
}

.navItem:hover {
    background: rgba(102, 126, 234, 0.08);
    color: #667eea;
}

.navItem.active {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
    color: #667eea;
    font-weight: 600;
}

.navItem.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 3px;
    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
    border-radius: 2px 2px 0 0;
}

.navIcon {
    font-size: 20px !important;
    transition: all 0.3s ease;
}

.navItem:hover .navIcon,
.navItem.active .navIcon {
    transform: scale(1.1);
}

/* Header Actions */
.headerActions {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}

/* Notification Button */
.notificationButton {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    background: rgba(102, 126, 234, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
}

.notificationButton:hover {
    background: rgba(102, 126, 234, 0.2);
    transform: translateY(-2px);
}

.notificationIcon {
    color: #667eea !important;
    font-size: 22px !important;
    transition: all 0.3s ease;
}

.notificationButton:hover .notificationIcon {
    transform: scale(1.1);
}

.notificationBadge .ant-badge-count {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    box-shadow: 0 2px 8px rgba(245, 87, 108, 0.4);
    border: 2px solid #ffffff;
    font-weight: 600;
    min-width: 20px;
    height: 20px;
    line-height: 18px;
    font-size: 11px;
}

/* Profile Button */
.profileButton {
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 12px;
    padding: 2px;
    border: 2px solid transparent;
}

.profileButton:hover {
    border-color: rgba(102, 126, 234, 0.3);
    transform: translateY(-2px);
}

.headingAvatar {
    border: 2px solid rgba(102, 126, 234, 0.2) !important;
    transition: all 0.3s ease;
    cursor: pointer;
}

.profileButton:hover .headingAvatar {
    border-color: rgba(102, 126, 234, 0.5) !important;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

/* Profile Popover */
.profilePopover .ant-popover-inner {
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    border: 1px solid rgba(102, 126, 234, 0.1);
}

.profilePopover .ant-popover-inner-content {
    padding: 0;
}

.profilePopover .ant-popover-title {
    padding: 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
    border-radius: 16px 16px 0 0;
}

.profileDropdown {
    padding: 8px 0;
    min-width: 180px;
}

.profileDropdownItem {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #4b5563;
    font-size: 14px;
    font-weight: 500;
}

.profileDropdownItem:hover {
    background: rgba(102, 126, 234, 0.08);
    color: #667eea;
    padding-left: 24px;
}

.profileDropdownIcon {
    font-size: 16px;
    color: #667eea;
}

.profileDropdownItem:first-child {
    border-radius: 0;
}

.profileDropdownItem:last-child {
    border-radius: 0 0 16px 16px;
}

/* Profile Title in Popover */
.Username {
    margin-bottom: 4px;
    margin-top: 0;
    font-size: 16px;
    font-weight: 600;
    color: #1f2937;
}

.Email {
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    color: #6b7280;
}

/* Legacy Styles (for compatibility) */
.pageHadingRow {
    display: none;
}

.headerSearch {
    margin-top: 13px;
}

.campaign {
    color: #000;
    line-height: 35px;
    font-size: 17.5px;
}

.Contents {
    cursor: pointer;
}

/* Responsive Design */
@media (max-width: 1200px) {
    .headerContainer {
        padding: 0 30px;
    }

    .headerNav {
        gap: 4px;
    }

    .navItem {
        padding: 10px 16px;
        font-size: 14px;
    }
}

@media (max-width: 768px) {
    .headerDiv {
        height: 60px;
    }

    .headerContainer {
        padding: 0 20px;
        height: 60px;
    }

    .headerLogoImg {
        width: 140px;
        height: auto;
    }

    .headerNav {
        gap: 4px;
        flex: 0 1;
    }

    .navItem {
        padding: 8px 12px;
        font-size: 13px;
    }

    .navItem span {
        display: none;
    }

    .navIcon {
        font-size: 22px !important;
    }

    .headerActions {
        gap: 12px;
    }

    .notificationButton {
        width: 40px;
        height: 40px;
    }

    .notificationIcon {
        font-size: 20px !important;
    }

    .headingAvatar {
        width: 36px !important;
        height: 36px !important;
    }
}

@media (max-width: 480px) {
    .headerContainer {
        padding: 0 16px;
    }

    .headerLogoImg {
        width: 120px;
    }

    .navItem {
        padding: 8px 10px;
    }

    .headerActions {
        gap: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;IACI,qCAAqC;IACrC,mCAA2B;YAA3B,2BAA2B;IAC3B,iDAAiD;IACjD,WAAW;IACX,UAAU;IACV,eAAe;IACf,WAAW;IACX,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;IACP,yBAAyB;AAC7B;;AAEA,eAAe;AACf;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,gGAAgG;IAChG,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,4DAA4D;IAC5D,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;AAEA,wBAAwB;AACxB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,6DAA6D;IAC7D,6CAA6C;IAC7C,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,+CAA+C;AACnD;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,4CAA4C;IAC5C,gGAAgG;IAChG,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,sBAAsB;AACtB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,SAAO;IACX;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;AACJ","sourcesContent":["/* Modern AI-Style Header */\n\n.headerDiv {\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(20px);\n    border-bottom: 1px solid rgba(102, 126, 234, 0.1);\n    color: #fff;\n    padding: 0;\n    position: fixed;\n    width: 100%;\n    z-index: 1000;\n    height: 70px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n    transition: all 0.3s ease;\n}\n\n.headerDiv:hover {\n    box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);\n}\n\n.headerContainer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 70px;\n    padding: 0 40px;\n    max-width: 1600px;\n    margin: 0 auto;\n}\n\n/* Left Section - Logo */\n.headerLeft {\n    display: flex;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.headerLogoImg {\n    cursor: pointer;\n    transition: all 0.3s ease;\n    height: auto;\n}\n\n.headerLogoImg:hover {\n    transform: scale(1.05);\n    opacity: 0.9;\n}\n\n/* Right Section */\n.headerRight {\n    display: flex;\n    align-items: center;\n    gap: 32px;\n    flex: 1;\n    justify-content: flex-end;\n}\n\n/* Navigation */\n.headerNav {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n    justify-content: center;\n}\n\n.navItem {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 15px;\n    font-weight: 500;\n    color: #4b5563;\n    position: relative;\n}\n\n.navItem:hover {\n    background: rgba(102, 126, 234, 0.08);\n    color: #667eea;\n}\n\n.navItem.active {\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);\n    color: #667eea;\n    font-weight: 600;\n}\n\n.navItem.active::after {\n    content: '';\n    position: absolute;\n    bottom: -1px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 60%;\n    height: 3px;\n    background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n    border-radius: 2px 2px 0 0;\n}\n\n.navIcon {\n    font-size: 20px !important;\n    transition: all 0.3s ease;\n}\n\n.navItem:hover .navIcon,\n.navItem.active .navIcon {\n    transform: scale(1.1);\n}\n\n/* Header Actions */\n.headerActions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    flex-shrink: 0;\n}\n\n/* Notification Button */\n.notificationButton {\n    width: 44px;\n    height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 12px;\n    background: rgba(102, 126, 234, 0.1);\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n}\n\n.notificationButton:hover {\n    background: rgba(102, 126, 234, 0.2);\n    transform: translateY(-2px);\n}\n\n.notificationIcon {\n    color: #667eea !important;\n    font-size: 22px !important;\n    transition: all 0.3s ease;\n}\n\n.notificationButton:hover .notificationIcon {\n    transform: scale(1.1);\n}\n\n.notificationBadge .ant-badge-count {\n    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n    box-shadow: 0 2px 8px rgba(245, 87, 108, 0.4);\n    border: 2px solid #ffffff;\n    font-weight: 600;\n    min-width: 20px;\n    height: 20px;\n    line-height: 18px;\n    font-size: 11px;\n}\n\n/* Profile Button */\n.profileButton {\n    cursor: pointer;\n    transition: all 0.3s ease;\n    border-radius: 12px;\n    padding: 2px;\n    border: 2px solid transparent;\n}\n\n.profileButton:hover {\n    border-color: rgba(102, 126, 234, 0.3);\n    transform: translateY(-2px);\n}\n\n.headingAvatar {\n    border: 2px solid rgba(102, 126, 234, 0.2) !important;\n    transition: all 0.3s ease;\n    cursor: pointer;\n}\n\n.profileButton:hover .headingAvatar {\n    border-color: rgba(102, 126, 234, 0.5) !important;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n/* Profile Popover */\n.profilePopover .ant-popover-inner {\n    border-radius: 16px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n    border: 1px solid rgba(102, 126, 234, 0.1);\n}\n\n.profilePopover .ant-popover-inner-content {\n    padding: 0;\n}\n\n.profilePopover .ant-popover-title {\n    padding: 20px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n    background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n    border-radius: 16px 16px 0 0;\n}\n\n.profileDropdown {\n    padding: 8px 0;\n    min-width: 180px;\n}\n\n.profileDropdownItem {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 20px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    color: #4b5563;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.profileDropdownItem:hover {\n    background: rgba(102, 126, 234, 0.08);\n    color: #667eea;\n    padding-left: 24px;\n}\n\n.profileDropdownIcon {\n    font-size: 16px;\n    color: #667eea;\n}\n\n.profileDropdownItem:first-child {\n    border-radius: 0;\n}\n\n.profileDropdownItem:last-child {\n    border-radius: 0 0 16px 16px;\n}\n\n/* Profile Title in Popover */\n.Username {\n    margin-bottom: 4px;\n    margin-top: 0;\n    font-size: 16px;\n    font-weight: 600;\n    color: #1f2937;\n}\n\n.Email {\n    margin: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    font-size: 13px;\n    color: #6b7280;\n}\n\n/* Legacy Styles (for compatibility) */\n.pageHadingRow {\n    display: none;\n}\n\n.headerSearch {\n    margin-top: 13px;\n}\n\n.campaign {\n    color: #000;\n    line-height: 35px;\n    font-size: 17.5px;\n}\n\n.Contents {\n    cursor: pointer;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n    .headerContainer {\n        padding: 0 30px;\n    }\n\n    .headerNav {\n        gap: 4px;\n    }\n\n    .navItem {\n        padding: 10px 16px;\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 768px) {\n    .headerDiv {\n        height: 60px;\n    }\n\n    .headerContainer {\n        padding: 0 20px;\n        height: 60px;\n    }\n\n    .headerLogoImg {\n        width: 140px;\n        height: auto;\n    }\n\n    .headerNav {\n        gap: 4px;\n        flex: 0;\n    }\n\n    .navItem {\n        padding: 8px 12px;\n        font-size: 13px;\n    }\n\n    .navItem span {\n        display: none;\n    }\n\n    .navIcon {\n        font-size: 22px !important;\n    }\n\n    .headerActions {\n        gap: 12px;\n    }\n\n    .notificationButton {\n        width: 40px;\n        height: 40px;\n    }\n\n    .notificationIcon {\n        font-size: 20px !important;\n    }\n\n    .headingAvatar {\n        width: 36px !important;\n        height: 36px !important;\n    }\n}\n\n@media (max-width: 480px) {\n    .headerContainer {\n        padding: 0 16px;\n    }\n\n    .headerLogoImg {\n        width: 120px;\n    }\n\n    .navItem {\n        padding: 8px 10px;\n    }\n\n    .headerActions {\n        gap: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
